<template>
  <p class="sword-input-error-wuk">
    <sword-icon-wuk v-if="showErrorFeedBack" name="circle-alert" />
    <span v-if="showErrorFeedBack">
      {{ $t(firstErrorMessage || manualError, firstError.params) }}
    </span>
  </p>
</template>

<script>
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor';

export default {
  name: 'InputErrorWuk',
  components: { SwordIconWuk },
  mixins: [singleErrorExtractorMixin],
  props: {
    manualError: {
      type: String,
      default: null
    }
  },
  computed: {
    showErrorFeedBack() {
      return (this.validator && this.firstErrorMessage && this.validator.$dirty && !this.validator.anyFocus) || this.manualError;
    },
  },
};
</script>
